// src/pages/DocumentManagementSystem/utils/downloadDmsAttachment.js
//
// Round DMS-P2-2 (2026) — audit gaps G1/G2.
//
// DMS attachment downloads now go through the AUTHORIZED endpoint
//   GET api/dms/{id}/attachments/download?fileName=...
// instead of an anonymous static /uploads URL (which Program.cs now denies
// for the DMS subfolders). A plain <a href> cannot carry the JWT, so this
// helper fetches the bytes with the axios instance (Authorization header
// attached) and triggers a client-side save — the exact pattern already
// used by Contract Review (useContractReviewApi.js: responseType "blob").
//
// Backward compatible: if a stale payload still carries an ABSOLUTE
// http(s) URL (pre-round cached tab state), fall back to window.open so
// nothing breaks mid-session.

import api from "../../../api";

export default async function downloadDmsAttachment(att) {
    const url = att?.downloadUrl;
    if (!url) return false;

    if (/^https?:\/\//i.test(url)) {
        // Legacy absolute static URL from a pre-round payload.
        window.open(url, "_blank");
        return true;
    }

    const res = await api.get(url, { responseType: "blob" });
    const blobUrl = URL.createObjectURL(res.data);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = att.fileName || "attachment";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
    return true;
}
